import { categories } from '@/mocks/heiliao';

interface CategorySectionProps {
  onSelect: (name: string) => void;
}

export default function CategorySection({ onSelect }: CategorySectionProps) {
  return (
    <section id="categories" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="reveal flex flex-col gap-5 border-b-2 border-foreground-950 pb-6 md:flex-row md:items-end md:justify-between">
          <div className="w-full">
            <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">DIRECTORY</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              主题分类目录
            </h2>
          </div>
          <p className="max-w-lg text-sm leading-relaxed text-foreground-600">
            六个主分区覆盖娱乐与舆论的主要方向。点击任意分区，即可跳到热度排行并按该分区筛选内容。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect(cat.name)}
              className="reveal group flex cursor-pointer items-stretch gap-4 overflow-hidden rounded-lg border border-background-300 bg-background-100 p-3 text-left transition-colors hover:border-primary-300 hover:bg-background-200"
            >
              <div className="h-[88px] w-[104px] shrink-0 overflow-hidden rounded-md">
                <img
                  src={cat.image}
                  alt={`${cat.name}分区封面`}
                  className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-between py-0.5">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="flex h-6 w-6 items-center justify-center rounded-sm bg-primary-100 text-primary-700">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                  </div>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
                </div>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-[11px] text-foreground-500">{cat.count} 条目录</span>
                  <span className="flex items-center gap-1 text-[11px] font-medium text-primary-600">
                    进入筛选
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}